import { UntypedFormControl, FormArray } from '@angular/forms';

export class DigitalAsset {
  _id: UntypedFormControl;
  originId: UntypedFormControl;
  assetType: UntypedFormControl;
  representation: UntypedFormControl;
  filename: UntypedFormControl;
}
